module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "module-list"
    }
  }, [_c('vue-topprogress', {
    ref: "topProgress",
    staticStyle: {
      "position": "relative",
      "right": "0px",
      "height": "7px"
    }
  }), _vm._v(" "), _c('b-row', [_c('div', {
    staticClass: "modal-body-content-module"
  }, [_c('div', {
    attrs: {
      "id": "plan1"
    }
  }, [_c('b-row', [_c('div', {
    staticClass: " module-title"
  }, [(_vm.paramsClient.nb_screen_segment !== 1) ? _c('span', {
    staticClass: "module-title--size"
  }, [_vm._v(_vm._s(_vm.$t('module.segment.title')))]) : _vm._e(), _vm._v(" "), (_vm.paramsClient.nb_screen_segment === 1) ? _c('span', {
    staticClass: "module-title--size"
  }, [_vm._v(_vm._s(_vm.$t('module.slide.title')))]) : _vm._e()])]), _vm._v(" "), _c('b-row', {
    staticClass: "header-module-block"
  }, [_c('b-col', {
    staticClass: "tabs-module-col",
    attrs: {
      "sm": "8"
    }
  }, [_c('div', {
    staticClass: " tabs-module"
  }, [_c('b-tabs', {
    attrs: {
      "active-nav-item-class": "font-weight-bold",
      "active-tab-class": "font-weight-bold text-success"
    }
  }, _vm._l((_vm.allTabs), function(tab, index) {
    return _c('b-tab', {
      key: index,
      attrs: {
        "title": _vm.$t('tabs.' + tab),
        "active": tab === _vm.activeModule
      },
      on: {
        "click": function($event) {
          return _vm.changeModule(tab)
        }
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('b-col', {
    staticClass: "search-col",
    attrs: {
      "sm": "4"
    }
  }, [_c('b-input-group', {
    staticClass: "search-group"
  }, [_c('b-input-group-append', {
    staticClass: " search-icon",
    on: {
      "click": function($event) {
        return _vm.searchTitle(true)
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "1.5em",
      "height": "1.5em",
      "viewBox": "0 0 40 40"
    }
  }, [_c('path', {
    attrs: {
      "id": "Color",
      "d": "M28.879,28.929a1.083,1.083,0,0,1-.76-.305l-6.96-6.712v-.072A13.25,13.25,0,0,1,7.772,23.775,12.758,12.758,0,0,1,3.4,20.785,12.074,12.074,0,0,1,3.763,3.629a13.2,13.2,0,0,1,17.791-.352A12.079,12.079,0,0,1,22.648,20.4h.075l6.96,6.712a1.007,1.007,0,0,1-.043,1.507A1.1,1.1,0,0,1,28.879,28.929ZM12.857,2.143A10.468,10.468,0,0,0,2.143,12.321a9.863,9.863,0,0,0,3.138,7.2A10.935,10.935,0,0,0,12.857,22.5a11.15,11.15,0,0,0,4.1-.775,10.724,10.724,0,0,0,3.476-2.206,10.11,10.11,0,0,0,2.322-3.3,9.7,9.7,0,0,0,.815-3.9,9.862,9.862,0,0,0-3.138-7.2A10.934,10.934,0,0,0,12.857,2.143Z",
      "transform": "translate(5 6)",
      "fill": "#7c7c7c"
    }
  })])]), _vm._v(" "), _c('b-form-input', {
    staticClass: "inputSearch",
    attrs: {
      "placeholder": _vm.$t('placeholder.search'),
      "id": "inputSearch"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchTitle(true)
      }
    },
    model: {
      value: (_vm.textToSearch),
      callback: function($$v) {
        _vm.textToSearch = $$v
      },
      expression: "textToSearch"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "close-module-list",
    attrs: {
      "id": "close-module-list"
    },
    on: {
      "click": function($event) {
        return _vm.searchTitle(false)
      }
    }
  }, [_c('i', {
    staticClass: "icon-close"
  })])], 1)], 1)], 1), _vm._v(" "), (_vm.activeModule === 'empty') ? _c('b-row', {
    staticClass: " d-flex justify-content-between"
  }, [_c('div', {
    directives: [{
      name: "has-permission",
      rawName: "v-has-permission",
      value: ('show_blank_layout_action'),
      expression: "'show_blank_layout_action'"
    }],
    staticClass: "default-modules"
  }, [_c('div', {
    staticClass: "one-disposition"
  }, [_c('slide-card', {
    attrs: {
      "id": "emptyDisposition",
      "isEditable": false,
      "isHover": false,
      "isEmpty": true,
      "item": _vm.empty,
      "isSelected": _vm.selecteIdSegment.includes(_vm.empty.id)
    },
    on: {
      "selected": function($event) {
        return _vm.addSegment(_vm.emptyDisposition, 'empty')
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.activeModule !== 'empty') ? _c('b-row', [_c('div', {
    staticClass: "default-modules"
  }, [_c('div', {
    staticClass: "list-modules"
  }, _vm._l((_vm.getComputedList), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "one-disposition"
    }, [_c('slide-card', {
      class: {
        'fix-height': _vm.activeModule === 'images'
      },
      attrs: {
        "have-screen": _vm.haveScreen(item),
        "Shot": _vm.screenShot(item),
        "isHover": true,
        "id": item.id,
        "item": item,
        "ModalSegment": true,
        "title": item.title,
        "itemsegment": item,
        "isSelected": _vm.selecteIdSegment.includes(item.id),
        "isActiveModule": _vm.activeModule,
        "isOldImages": _vm.activeModule === 'images' && _vm.oldImages
      },
      on: {
        "selected": function($event) {
          return _vm.addSegment(item)
        },
        "showSelect": function($event) {
          return _vm.showSelect($event, item, index)
        }
      }
    })], 1)
  }), 0), _vm._v(" "), _c('infinite-loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.noMoreMedias),
      expression: "!noMoreMedias"
    }],
    staticClass: "infinite-loading-container",
    attrs: {
      "distance": 10,
      "direction": 'bottom',
      "spinner": "bubbles"
    },
    on: {
      "infinite": _vm.loadMoreVideos
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.noMoreMedias),
      expression: "noMoreMedias"
    }],
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.noResultMedias),
      expression: "noResultMedias"
    }],
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  })])], 1)]) : _vm._e(), _vm._v(" "), _c('b-row', [_c('div', {
    staticClass: " timeline-title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('module.timeline.title')))])])]), _vm._v(" "), _c('b-row', [_c('div', {
    staticClass: "timeline-modules"
  }, [_c('div', {
    staticClass: "col-xs-1"
  }, [_c('div', {
    staticClass: "button-navigation button-navigation__left",
    class: [{
      active: _vm.hasScrollSlides
    }]
  }, [_c('button', {
    staticClass: "  button-navigation--left btn btn-sm pl-1 pr-1",
    attrs: {
      "id": "button-navigation-left",
      "disabled": !_vm.hasScrollSlides
    },
    on: {
      "click": function($event) {
        return _vm.dragSlide($event, -1, 'module-list')
      }
    }
  }, [_c('div', {
    staticClass: "icon-navigation-left"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 32 32",
      "width": "20px",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "fill": "#939ea7"
    }
  }, [_c('path', {
    attrs: {
      "d": "M28.41,13.59l-10-10a2,2,0,0,0-2.82,2.82L24.17,15l-8.58,8.59a2,2,0,1,0,2.82,2.82l10-10A2,2,0,0,0,28.41,13.59Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16.41,13.59l-10-10A2,2,0,0,0,3.59,6.41L12.17,15,3.59,23.59a2,2,0,1,0,2.82,2.82l10-10A2,2,0,0,0,16.41,13.59Z"
    }
  })])])])])])]), _vm._v(" "), _c('b-col', {
    staticClass: "div-draggable-margin",
    attrs: {
      "sm": "11"
    }
  }, [_c('div', {
    staticClass: "slides-panel row",
    attrs: {
      "id": "div-draggable"
    }
  }, [_c('VuePerfectScrollbar', {
    ref: "ps",
    staticClass: "scroll-area",
    attrs: {
      "id": "ps-slide-wrapper",
      "use-both-wheel-axes": true
    }
  }, [_c('div', {
    staticClass: "row__inner",
    on: {
      "mousewheel": _vm.scrollHorizontally
    }
  }, [_c('draggable', {
    attrs: {
      "id": "draggable-wrapper",
      "move": _vm.dragSlide
    },
    on: {
      "end": _vm.reorder,
      "start": _vm.getList
    },
    model: {
      value: (_vm.list),
      callback: function($$v) {
        _vm.list = $$v
      },
      expression: "list"
    }
  }, _vm._l((_vm.moduleSelected), function(slide, index) {
    return _c('div', {
      key: 'list-complete-module-list' + slide.id,
      staticClass: "card-wrapper",
      class: {
        extended: slide.isExtended
      },
      attrs: {
        "data-uid": slide.uid
      }
    }, [_c('span', {
      staticClass: "counter-slides"
    }, [_vm._v("\n                          " + _vm._s(index + 1) + "\n                        ")]), _vm._v(" "), _c('panel-card', {
      attrs: {
        "index": index,
        "slide": slide,
        "isSelected": slide.uid === _vm.currentSegment.uid,
        "removable": _vm.all.length > 1,
        "showVideoIntro": {},
        "isSegmentCard": true,
        "isModuleList": true
      },
      on: {
        "remove-segment": function($event) {
          return _vm.addSegment(slide)
        }
      }
    })], 1)
  }), 0)], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1"
  }, [_c('div', {
    staticClass: "button-navigation button-navigation__right",
    class: [{
      active: _vm.hasScrollSlides
    }]
  }, [_c('button', {
    staticClass: " button-navigation--right btn btn-sm pl-1 pr-1",
    attrs: {
      "id": "button-navigation-right",
      "disabled": !_vm.hasScrollSlides
    },
    on: {
      "click": function($event) {
        return _vm.dragSlide($event, 1, 'module-list')
      }
    }
  }, [_c('div', {
    staticClass: "icon-navigation-right"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 32 32",
      "width": "20px",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "fill": "#939ea7"
    }
  }, [_c('path', {
    attrs: {
      "d": "M28.41,13.59l-10-10a2,2,0,0,0-2.82,2.82L24.17,15l-8.58,8.59a2,2,0,1,0,2.82,2.82l10-10A2,2,0,0,0,28.41,13.59Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16.41,13.59l-10-10A2,2,0,0,0,3.59,6.41L12.17,15,3.59,23.59a2,2,0,1,0,2.82,2.82l10-10A2,2,0,0,0,16.41,13.59Z"
    }
  })])])])])])])], 1)]), _vm._v(" "), _c('b-row', {
    staticClass: "position-buttons"
  }, [(!_vm.hideCancelButton) ? _c('button', {
    class: ['btn outline-primary position-buttons__cancel'],
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('i', {
    class: ['fa fa-arrow-left']
  }), _vm._v(" " + _vm._s(_vm.$t('button.back')) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.hideCancelButton && !_vm.navparam) ? _c('button', {
    class: ['btn outline-primary position-buttons__next'],
    attrs: {
      "id": "btn-next"
    },
    on: {
      "click": function($event) {
        _vm.onNav(), _vm.changeStyleOn()
      }
    }
  }, [_c('i', {
    class: ['fa fa-arrow-left']
  }), _vm._v(" " + _vm._s(_vm.$t('button.back')) + "\n          ")]) : _vm._e(), _vm._v(" "), (!_vm.hideCancelButton) ? _c('button', {
    class: ['btn btn-primary position-buttons__confirm'],
    attrs: {
      "disabled": _vm.disabledConfirmButton
    },
    on: {
      "click": function($event) {
        return _vm.confirm()
      }
    }
  }, [_c('i', {
    class: ['fa fa-check']
  }), _vm._v(" " + _vm._s(_vm.$t('button.confirm')) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.hideCancelButton && !_vm.navparam) ? _c('b-button', {
    staticClass: "position-buttons__finish",
    attrs: {
      "id": "btn-finish",
      "type": "submit",
      "variant": "primary",
      "disabled": _vm.confirmButtonDisabled
    },
    on: {
      "click": _vm.confirm
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" " + _vm._s(_vm.$t('button.finish')) + "\n          ")]) : _vm._e()], 1), _vm._v("\n        " + _vm._s(_vm.isScreen) + "\n      ")], 1), _vm._v(" "), (!_vm.isScreen) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.navparam),
      expression: "navparam"
    }],
    attrs: {
      "id": "plan2"
    },
    on: {
      "click": function($event) {
        _vm.clicksOut = false
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "content-plan2"
    }
  }, [_c('b-card', {
    attrs: {
      "id": "card-add-prog"
    }
  }, [_c('div', {
    staticClass: "icon-add-prog"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "60",
      "height": "60",
      "viewBox": "0 0 30 30"
    }
  }, [_c('path', {
    attrs: {
      "id": "Color",
      "d": "M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z",
      "transform": "translate(3.75 3.75)",
      "fill": "#acadb1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "text-left"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('addProgram.add')))]), _vm._v(" "), (_vm.options.length > 0) ? _c('h6', {
    staticStyle: {
      "color": "#686866"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('addProgram.textAddLigne')) + "\n              ")]) : _c('h6', {
    staticStyle: {
      "color": "#68686b"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('addProgram.textAdd')) + "\n              ")])])]), _vm._v(" "), _c('b-row', {
    staticClass: "my-2 d-flex justify-content-between"
  }, [_c('b-col', [_c('b-form-group', {
    staticClass: "text-left",
    attrs: {
      "id": "input-group-title",
      "label": _vm.$t('labels.title'),
      "label-for": "input-titre"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "input-titre",
      "state": _vm.stateTitle,
      "required": "",
      "placeholder": _vm.$t('placeholder.title')
    },
    model: {
      value: (_vm.getTitleSegment),
      callback: function($$v) {
        _vm.getTitleSegment = $$v
      },
      expression: "getTitleSegment"
    }
  })], 1)], 1), _vm._v(" "), (_vm.options.length > 0) ? _c('b-col', {
    directives: [{
      name: "has-permission",
      rawName: "v-has-permission",
      value: ('use_ligne_template_action'),
      expression: "'use_ligne_template_action'"
    }]
  }, [_c('b-form-group', {
    staticClass: "text-left",
    attrs: {
      "id": "input-group-title",
      "label": _vm.$t('labels.ligne'),
      "label-for": "input-titre"
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "required": "",
      "state": _vm.stateLigne,
      "id": "input-ligne"
    },
    model: {
      value: (_vm.ligneTemplate),
      callback: function($$v) {
        _vm.ligneTemplate = $$v
      },
      expression: "ligneTemplate"
    }
  }, _vm._l((_vm.options), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.name,
        "value": option.value
      }
    }, [_vm._v("\n                    " + _vm._s(option.name) + "\n                  ")])
  }), 0)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "text-right"
  }, [_c('b-button', {
    staticClass: "lg-btn",
    attrs: {
      "variant": "outline-secondary"
    },
    on: {
      "click": function($event) {
        return _vm.BackToBoProgram()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('button.cancel')) + "\n              ")]), _vm._v(" "), (_vm.navparam) ? _c('b-button', {
    staticClass: "lg-btn",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.onNav(), _vm.changeStyleOff()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('button.next')) + "\n              ")]) : _vm._e()], 1)], 1)], 1)]) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e9479ae","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModuleList.vue
// module id = 829
// module chunks = 1 3